export const RedSearchErrorIcon = () => (
	// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g id="tdesign:search-error">
			<path
				id="Vector"
				d="M15.0968 5.90376C14.1876 4.99422 13.029 4.37483 11.7676 4.12399C10.5062 3.87315 9.19881 4.00212 8.01077 4.4946C6.82272 4.98707 5.80747 5.82091 5.0935 6.89058C4.37952 7.96026 3.9989 9.2177 3.99981 10.5038L4.00081 11.5038H2.00081V10.5038C2.00029 9.14819 2.32399 7.81215 2.9449 6.60713C3.56581 5.40212 4.46593 4.36309 5.57012 3.57674C6.67432 2.7904 7.95057 2.27955 9.29238 2.08683C10.6342 1.89411 12.0026 2.02511 13.2835 2.46889C14.5644 2.91267 15.7205 3.65637 16.6555 4.63792C17.5905 5.61946 18.2771 6.81039 18.6581 8.11132C19.0392 9.41225 19.1035 10.7854 18.8458 12.1163C18.5881 13.4472 18.0159 14.6971 17.1768 15.7618L22.5208 21.1068L21.1068 22.5208L15.7628 17.1758C14.264 18.3592 12.4095 19.0019 10.4998 18.9998H9.49981V16.9998H10.4998C11.7853 16.9997 13.042 16.6184 14.1108 15.9042C15.1797 15.19 16.0127 14.1748 16.5047 12.9872C16.9966 11.7995 17.1253 10.4926 16.8745 9.23178C16.6238 7.97096 16.0048 6.8128 15.0958 5.90376M1.67181 13.2568L4.49981 16.0858L7.32881 13.2568L8.74281 14.6718L5.91481 17.4998L8.74281 20.3278L7.32881 21.7428L4.49981 18.9138L1.67181 21.7428L0.257812 20.3278L3.08581 17.4998L0.257812 14.6718L1.67181 13.2568Z"
				fill="#DA4730"
			/>
		</g>
	</svg>
);
